<template>
    <v-card>
        <v-card-title v-if="title">
            <h3 class="headline">Plano de Assinatura</h3>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent="salvarPlano" ref="form">
            <CardAssinatura
                v-if="inscricao && assinatura"
                :inscricao="{ ...inscricao, assinatura: assinatura }"
                :autenticado="autenticado"
                :appSelected="null"
                :pessoa="pessoa"
                @assinaturaCancelada="$emit('assinaturaCancelada')"
                :ehAreaDoUsuario="true"
            />
            <v-btn
              v-if="assinatura && assinatura.plano.itens && assinatura.plano.itens.length > 0" block flat color="primary"
              @click="editarInformacoes = !editarInformacoes"
            >
              <v-icon class="mr-1">{{  editarInformacoes ? 'close' : 'edit' }}</v-icon>
              {{ editarInformacoes ? 'Cancelar' : 'Editar' }}
            </v-btn>
            <template v-if="editarInformacoes">
              <v-text-field
                v-model="form.valor"
                label="Valor"
                :rules="[(v) => !!v || 'Valor é obrigatório']"
                required
                outline
                v-money="money"
                :disabled="!!assinatura"
                @blur="aplicarDesconto"
              ></v-text-field>
              <div v-if="form.percentualDesconto > 0" style="font-size: 16px; font-weight: bold; margin-top: -16px; margin-bottom: 16px;">
                Desconto aplicado:
                <span style="color: green;">{{ form.percentualDesconto }}%</span><br>
                Valor final:
                <span style="color: green;">R$ {{ form.valorComDesconto.toFixed(2).replace('.', ',') }}</span>
              </div>
              <v-textarea
                v-model="form.descricao"
                label="Descrição"
                :rules="[(v) => !!v || 'Descrição é obrigatória']"
                required
                outline
                maxlength="200"
                counter="200"
              ></v-textarea>
              <v-select
                label="Gateway"
                v-model="form.gateway"
                :items="gateways"
                outline
                item-value="value"
                item-text="text"
                required
                clearable
              ></v-select>
              <v-select
                item-text="descricao"
                item-value="id_tipo_pagamento"
                label="Tipo de pagamento"
                v-model="form.tipos_pagamento_selecionados"
                :items="tipos_pagamentos"
                outline
                required
                multiple
                attach
                chips
                hide-spin-buttons
                hide-details
              ></v-select>
              <v-layout
                row
                wrap
                justify-space-between
                class="pa-2"
                v-if="(assinatura && assinatura.plano.itens && assinatura.plano.itens.length > 0) || !assinatura"
              >
                <v-flex xs11>
                  <h2 class="text-xs-center ml-4">Insira os itens no plano</h2>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small v-on="on" icon color="secondary" @click="dialogCadItem = true">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </template>
                    <span>Cadastrar novo Item</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs6>
                  <h4 class="text-xs-center">Itens disponíveis</h4>
                  <v-text-field
                    v-model="filtro_nome"
                    label="Filtrar"
                    single-line
                    hide-details
                    placeholder="Digite o nome do item"
                    outline
                    class="mb-4"
                  >
                    <template v-slot:append>
                      <v-icon
                        @click="() => {}"
                      >
                        search
                      </v-icon>
                    </template>
                  </v-text-field>
                  <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em;" class="mr-1">
                    <v-list-tile v-for="(item, index) in [...itens].filter(item => item.nome.toLowerCase().includes(filtro_nome.toLowerCase()))" :key="index" ripple
                      @click="inserirNoPlano(item, index)">
                      <v-list-tile-avatar>
                        <img v-if="item.imagens && item.imagens.length > 0" :src="item.imagens[0].url" alt="Imagem do item" width="30">
                        <v-icon v-else>image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center">{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text-xs-center">{{ item.preco | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="itens.length === 0">
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center">Sem itens no momento</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs6>
                  <h4 class="text-xs-center">Itens incluídos</h4>
                  <v-text-field
                    v-model="filtro_nome2"
                    label="Filtrar"
                    single-line
                    hide-details
                    placeholder="Digite o nome do item"
                    outline
                    class="mb-4"
                  >
                    <template v-slot:append>
                      <v-icon
                        @click="() => {}"
                      >
                        search
                      </v-icon>
                    </template>
                  </v-text-field>
                  <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em" class="ml-1">
                    <v-list-tile v-for="(item, index) in [...form.itens].filter(item => item.nome.toLowerCase().includes(filtro_nome2.toLowerCase()))" :key="index" ripple
                      @click="removerDoPlano(item, index)">
                      <v-list-tile-avatar>
                        <img v-if="item.imagens && item.imagens.length > 0" :src="item.imagens[0].url" alt="Imagem do item" width="30">
                        <v-icon v-else>image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center">{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text-xs-center">{{ item.preco | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-if="form.itens.length === 0">
                      <v-list-tile-content>
                        <v-list-tile-title class="text-xs-center">Sem itens no momento</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </template>
          </v-form>
        </v-card-text>
        <v-card-text>
          <v-layout justify-space-around wrap class="mb-2">
              <v-flex xs9>
                  <h6
                      class="mb-2 text-xs-center"
                      style="
                          font-size: 1.1em;
                          margin-left: 9em;
                      "
                  >
                      Digite o PIN do frentista responsável
                  </h6>
              </v-flex>
              <v-flex xs2>
                  <v-icon size="40">engineering</v-icon>
              </v-flex>
              <v-flex xs10>
                  <h4>Lido por: {{frentista.nome}}</h4>
                  <h4>Matricula: {{frentista.matricula}}</h4>
              </v-flex>
          </v-layout>
          <Pin v-if="!autenticado" :frentista="frentista" @autenticado="autenticado = true"/>
          <h3 v-else class="success--text text-xs-center mt-3 mb-3">A leitura já pode ser realizada</h3>
        </v-card-text>
        <v-card-actions class="justify-space-between" v-if="editarInformacoes">
          <!-- <v-flex xs6>
            <v-btn
              block
              flat
              @click="step = 1"
            >
              Voltar
          </v-btn>
          </v-flex> -->
          <v-flex xs12>
            <v-btn
              color="primary"
              block
              flat
              @click="salvarPlano"
              :disabled="!autenticado || !form.gateway || !form.valor || !form.descricao"
            >
              Salvar</v-btn>
          </v-flex>
        </v-card-actions>
        <v-dialog v-if="dialogCadItem" v-model="dialogCadItem"  width="65em" :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
          <cad-item
            @fechar="dialogCadItem = false"
            @carregar="pegarTodosItens"
          />
      </v-dialog>
    </v-card>
</template>
<script>
import { VMoney } from 'v-money'
import CardAssinatura from '@/components/CardAssinatura.vue'
import CadItem from '@/components/dialogs/CadItem.vue'
import Pin from '@/components/Pin'

export default {
  directives: { money: VMoney },
  components: { CardAssinatura, CadItem, Pin },
  props: ['title', 'assinatura', 'pessoa', 'inscricao'],
  data: () => ({
    dialogCadItem: false,
    editarInformacoes: false,
    valid: false,
    form: {
      descricao: '',
      valor: '',
      valorComDesconto: 0,
      percentualDesconto: 0,
      itens: [],
      gateway: 1,
      intervalo: 1,
      tipos_pagamento_selecionados: []
    },
    filtro_nome: '',
    filtro_nome2: '',
    itens: [],
    gateways: [],
    tipos_pagamentos: [],
    autenticado: false,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2
    }
  }),
  computed: {
    empresa () {
      return this.$store.getters.empresa
    },
    loading () {
      return this.$store.getters.loading
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    frentista () {
      return this.$store.getters.frentista
    }
  },
  mounted () {
    this.pegarTiposDePagamento()
    this.carregarMeiosDePagamento()
    if (this.assinatura) {
      this.form.valor = this.assinatura.plano.valor
      this.form.descricao = this.assinatura.plano.descricao
      this.pegarItensDoPlano()
    } else {
      this.editarInformacoes = true
    }
    this.pegarTodosItens()
  },
  methods: {
    pegarTiposDePagamento () {
      this.$store.dispatch('pegarTiposDePagamento').then(json => {
        this.tipos_pagamentos = json.filter((tipo) => ['pix', 'boleto', 'credito'].includes(tipo.referencia))
      })
    },
    carregarMeiosDePagamento () {
      this.$store.dispatch('pegarMeiosDePagamento').then((json) => {
        json.map(meio => {
          if (meio.forma_pagamento && meio.forma_pagamento.descricao.toLowerCase() === 'asaas') {
            this.gateways.push({ text: 'ASAAS', value: 2 })
          } else if (meio.forma_pagamento && meio.forma_pagamento.descricao.toLowerCase() === 'efi') {
            this.gateways.push({ text: 'EFI', value: 1 })
          }
        })
      })
    },
    salvarPlano () {
      let valorFinal
      if (this.form.percentualDesconto > 0 && this.form.valorComDesconto) {
        valorFinal = this.form.valorComDesconto
      } else {
        valorFinal = Number(this.form.valor.replace('R$ ', '').replace('.', '').replace(',', '.'))
      }
      const data = {
        method: this.assinatura ? 'PUT' : 'POST',
        id: this.assinatura ? this.assinatura.plano.id : undefined,
        body: {
          descricao: this.form.descricao,
          itens: this.form.itens.map(item => item.id),
          empresa: this.empresa ? this.empresa.cnpj : null,
          id_frentista: this.frentista.id_frentista,
          gateway: this.form.gateway ? this.form.gateway : null,
          intervalo: this.form.intervalo ? this.form.intervalo : null
        }
      }
      if (this.form.tipos_pagamento_selecionados.length > 0) data.body.tipos_pagamento = this.form.tipos_pagamento_selecionados
      if (!this.assinatura) data.body.valor = valorFinal
      if (this.pessoa) data.body.id_pessoa = this.pessoa.id_pessoa
      this.$store.dispatch('planoComItens', data).then(() => {
        this.$refs.form.reset()
        this.step = 1
        this.$emit('planoCadastrado')
      })
    },
    pegarTodosItens () {
      const data = {
        parameters: {}
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens = this.assinatura ? json.filter(item => !this.assinatura.plano.itens.includes(item.id)) : json
      })
    },
    pegarItensDoPlano () {
      if (this.assinatura.plano.itens && this.assinatura.plano.itens.length === 0) {
        this.form.itens = []
        return
      }
      const data = {
        parameters: {
          id__in: this.assinatura.plano.itens
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.form.itens = json
      })
    },
    inserirNoPlano (item, index) {
      this.form.itens.push(item)
      this.itens.splice(index, 1)
    },
    removerDoPlano (item, index) {
      this.itens.push(item)
      this.form.itens.splice(index, 1)
    },
    aplicarDesconto () {
      this.$store.dispatch('aplicarDescontoFidelize', { valor: this.form.valor.toString().replace(/R\$\s?/, '').replace(',', '.') })
        .then((json) => {
          if (json.valor !== null && json.percentual !== null) {
            this.form.valorComDesconto = json.valor
            this.form.percentualDesconto = json.percentual
          } else {
            this.form.percentualDesconto = 0
          }
        })
    }
  }
}
</script>
